export default __webpack_public_path__ + "fonts/dfeba9bf65c2be352b9d9c4d8f19272e.svg";